import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Box } from '@mui/material'
import { CarrierVisitStatus } from '@planning/app/api'
import { FC } from 'react'
import {
  isRailcarPlanningIdentifierOfType,
  RailcarPlanningDraggableEnum,
  RailcarPlanningViewStore,
} from '../../Stores/RailcarPlanningViewStore'
import {
  RailcarPlanningContainer,
  RailcarPlanningContainerProps,
} from '../Molecules/RailcarPlanningContainer'

type Props = {
  railcarPlanningViewStore: RailcarPlanningViewStore
  container: RailcarPlanningContainerProps
  filter?: string | null
  widthBasedOnContainerSize?: boolean
}

export const RailcarPlanningDraggableContainer: FC<Props> = props => {
  const { container, railcarPlanningViewStore, widthBasedOnContainerSize = false } = props
  const id = `${RailcarPlanningDraggableEnum.CONTAINER}:${container.id}`
  const { attributes, listeners, transform, transition, active, setNodeRef } = useSortable({
    id,
    disabled: railcarPlanningViewStore.railVisitItem.data.status === CarrierVisitStatus.Closed,
    data: {
      type: RailcarPlanningDraggableEnum.CONTAINER,
      ...container,
    },
  })

  const isDraggingThisContainer =
    !!active?.id &&
    active.id === id &&
    isRailcarPlanningIdentifierOfType(active.id, RailcarPlanningDraggableEnum.CONTAINER)

  const opacity = isDraggingThisContainer ? `0.5` : '1'
  const ratio = 10
  const containerWidth = widthBasedOnContainerSize
    ? `${(props.container.size ?? 20) * ratio}px`
    : 'auto'

  return (
    <Box
      ref={setNodeRef}
      sx={{
        width: `${containerWidth}`,
        transform: CSS.Transform.toString(transform),
        opacity: isDraggingThisContainer ? opacity : '1',
        transition,
        cursor: 'grab',
      }}
      {...listeners}
      {...attributes}
    >
      <RailcarPlanningContainer {...props.container} filter={props.filter} />
    </Box>
  )
}
